import {
  FETCH_VEHICLE_DATA,
  SET_VEHICLE_DATA,
  SET_SEARCH_TEXT,
  FETCH_WALLET_BALANCE,
  SET_WALLET_BALANCE,
} from './constants';

export const fetchVehicleData = (params: object) => ({
  type: FETCH_VEHICLE_DATA,
  data: params,
});

export const setVehicleData = (data: object) => ({
  type: SET_VEHICLE_DATA,
  data,
});

export const getVehicleParams = ({ searchText = '', page = 0, pageSize = 20, details = false, noReset = false }) => {
  const params = [],
    requestParams: any = {};
  if (searchText) {
    params.push(`searchText=${searchText}`);
  }
  if (page) {
    params.push(`pageNo=${page}`);
  }
  params.push(`pageSize=${pageSize}`);

  requestParams['query'] = params.join('&');
  requestParams['isDetail'] = details;
  requestParams['noReset'] = noReset;
  requestParams['vNum'] = searchText;

  return {
    type: FETCH_VEHICLE_DATA,
    data: requestParams,
  };
};

export const setSearchText = (searchText: string) => {
  return {
    type: SET_SEARCH_TEXT,
    data: searchText,
  };
};

export const fetchWalletBalance = () => {
  return {
    type: FETCH_WALLET_BALANCE,
  };
};

export const setWalletBalance = (balance?: number) => {
  return {
    type: SET_WALLET_BALANCE,
    data: balance,
  };
};
